import styled from 'styled-components';
import {
  BREAKPOINTS,
  BREAKPOINTS_NUM,
} from 'constants/Global/Breakpoints.const';

export const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;

  svg {
    height: 16px;
    width: 16px;
  }

  .button-cart-text-desktop {
    display: none;
  }

  .button-text-mobile {
    display: inline;
    font-size: 0.875rem;
    font-weight: 400;
  }

  .flexible-text {
    flex: 1;
  }

  @media (max-width: ${BREAKPOINTS_NUM.desktop - 1}px) {
    flex: 1;

    .inline-buttons button.small {
      flex: 0;
    }
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    .button-text-desktop {
      display: inline;
    }

    .button-text-mobile {
      display: none;
    }
  }

  &.default {
    .inline-button,
    .inline-buttons {
      display: contents;
    }
  }

  &.stacked {
    flex-direction: column;
    gap: 8px;

    .stacked-row {
      display: flex;
      gap: 8px;

      &.full-width {
        width: 100%;

        button {
          flex: 1;
        }
      }

      &.split-width {
        flex-wrap: wrap;

        button {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .text-button {
          flex: 2;
        }

        .icon-button {
          flex: 0 0 auto;
          min-width: 48px;
        }

        @media (max-width: ${BREAKPOINTS_NUM.desktop - 1}px) {
          justify-content: center;

          .icon-button {
            justify-content: center;
          }
        }
      }

      .inline-button,
      .inline-buttons {
        display: flex;
        gap: 8px;
      }
    }
  }
`;

export const BuyButtonWrapper = styled.span`
  display: inline-flex;
  flex: 1;
`;
